import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom"; // عشان نجيب الـ ID من الرابط
import { getArticleById } from "../firestoreServices";
import { Helmet } from "react-helmet-async"; // اختياري للـ SEO

const ArticleDetails = ({ lang }) => {
  const { id } = useParams(); // هنجيب الـ ID من الـ URL
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      const data = await getArticleById(id);
      setArticle(data);
      setLoading(false);
    };
    fetchArticle();
  }, [id]);

  if (loading) return <div className="text-center py-20">Loading...</div>;
  if (!article)
    return <div className="text-center py-20">Article not found</div>;

  const data = article[lang] || article.en;
  const isAr = lang === "ar";

  return (
    <div className="article-page" dir={isAr ? "rtl" : "ltr"}>
      {/* SEO Tags */}
      <Helmet>
        <title>{data.title} | El-Wakil Law Firm</title>
        <meta name="description" content={data.excerpt} />
      </Helmet>

      {/* Hero Section للصورة */}
      <div
        className="article-header"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${article.img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "100px 0",
          textAlign: "center",
          color: "white",
        }}
      >
        <div className="container">
          <span
            className="article-tag"
            style={{
              background: "#c5a059",
              padding: "5px 15px",
              borderRadius: "20px",
              fontSize: "14px",
            }}
          >
            {data.category}
          </span>
          <h1
            style={{ fontSize: "2.5rem", margin: "20px 0", fontWeight: "bold" }}
          >
            {data.title}
          </h1>
          <span className="article-date">{article.date}</span>
        </div>
      </div>

      {/* محتوى المقال */}
      <div
        className="container"
        style={{ maxWidth: "900px", margin: "50px auto", padding: "0 20px" }}
      >
        {/* زر العودة */}
        <Link
          to="/"
          style={{
            display: "inline-block",
            marginBottom: "20px",
            color: "#c5a059",
            fontWeight: "bold",
            textDecoration: "none",
          }}
        >
          {isAr ? "← العودة للرئيسية" : "← Back to Home"}
        </Link>

        {/* عرض المحتوى HTML */}
        <div
          className="article-body ql-editor" // ql-editor كلاس من المكتبة عشان يظبط التنسيق
          dangerouslySetInnerHTML={{ __html: data.content }}
          style={{ lineHeight: "1.8", fontSize: "18px", color: "#333" }}
        />
      </div>
    </div>
  );
};

export default ArticleDetails;
